'use client';

import React, { useId } from 'react';
import clsx from 'clsx';
const TIMELINE_ACCENT_STYLES = {
  blue: {
    rail: 'var(--status-info)',
    badgeBg: 'var(--status-info)',
    badgeText: '#fff',
    title: 'var(--status-info)',
    dot: 'var(--status-info)'
  },
  amber: {
    rail: 'var(--status-warning)',
    badgeBg: 'var(--status-warning)',
    badgeText: '#fff',
    title: 'var(--status-warning)',
    dot: 'var(--status-warning)'
  },
  green: {
    rail: 'var(--status-success)',
    badgeBg: 'var(--status-success)',
    badgeText: '#fff',
    title: 'var(--status-success)',
    dot: 'var(--status-success)'
  }
};
function InterviewTimelineRoot({
  children,
  className
}) {
  return <div className={clsx('flex flex-col gap-6 pr-1', className)}>{children}</div>;
}
function InterviewTimelineSection({
  title,
  accent,
  count,
  children
}) {
  const styles = TIMELINE_ACCENT_STYLES[accent];
  if (count === 0) return null;
  return <div className="flex flex-col gap-3">
            <div className="flex items-center gap-2 w-full mt-2">
                <span className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{
        background: styles.dot
      }} />
                <span className="text-sm font-bold whitespace-nowrap" style={{
        color: styles.title
      }}>
                    {title}({count})
                </span>
                <span className="flex-1 border-t border-border mx-1" />
            </div>
            <div className="flex flex-col">{children}</div>
        </div>;
}
function InterviewTimelineItem({
  roundNum,
  accent,
  isLast,
  children
}) {
  const arcId = `rnd-arc-${useId().replace(/:/g, '')}`;
  const styles = TIMELINE_ACCENT_STYLES[accent];
  const hasRound = roundNum != null && roundNum > 0;
  // Space for the curved label above the badge (incl. mb-1 gap) so the connector still centers on the circle
  const connectorOffsetPx = 14;
  return <div className="flex items-stretch">
            <div className="flex flex-col items-center w-12 flex-shrink-0">
                <div className="relative mt-3.5 flex h-9 w-9 items-center justify-center">
                    <svg aria-hidden viewBox="0 0 52 52" className="pointer-events-none absolute left-1/2 top-1/2 h-[52px] w-[52px] -translate-x-1/2 -translate-y-1/2 overflow-visible text-foreground-subtle">
                        <defs>
                            {/* Arc ~mb-1 (4px) above the 36px badge edge */}
                            <path id={arcId} d="M 11 12 Q 26 -3 41 12" fill="none" />
                        </defs>
                        <text fill="currentColor" style={{
            fontSize: 8,
            fontWeight: 600,
            letterSpacing: '0.22em'
          }}>
                            <textPath href={`#${arcId}`} startOffset="50%" textAnchor="middle">
                                RND
                            </textPath>
                        </text>
                    </svg>
                    <div className="relative z-10 flex h-9 w-9 items-center justify-center rounded-full text-sm font-bold" style={{
          background: hasRound ? styles.badgeBg : 'var(--muted)',
          color: hasRound ? styles.badgeText : 'var(--foreground-muted)'
        }}>
                        {hasRound ? roundNum : '–'}
                    </div>
                </div>
                {!isLast && <div className="w-0.5 flex-1 min-h-[16px] mt-1" style={{
        background: styles.rail
      }} />}
            </div>

            {/* Equal gap (8px) on each side of the connector; row centered on the circle */}
            <div className="shrink-0 h-9 flex items-center -ml-1.5" style={{
      marginTop: connectorOffsetPx
    }}>
                <div className="w-3 h-px bg-border" />
            </div>

            <div className="flex-1 min-w-0 pb-4">{children}</div>
        </div>;
}
export const InterviewTimeline = Object.assign(InterviewTimelineRoot, {
  Section: InterviewTimelineSection,
  Item: InterviewTimelineItem
});